import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NoticiasCadastroComponent } from './noticias-cadastro/noticias-cadastro.component';
import { NoticiasPesquisaComponent } from './noticias-pesquisa/noticias-pesquisa.component';
import { NoticiasService } from './noticias.service';


import { SharedsModule } from '../shareds/shareds.module';

@NgModule({
  imports: [
    SharedsModule,
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  declarations: [NoticiasCadastroComponent, NoticiasPesquisaComponent],
  providers:[ NoticiasService,]
})
export class NoticiasModule { }
